import React, { useEffect, useState } from 'react';
import { ReactComponent as Pencil } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import { Input } from 'antd';
import { Select } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { clearUserGroups, getGroupById, getGroups, getUserData, updateUser, updateUserGroup } from 'store/adminPanel/actions';

const EditModal = ({ isVisible, setVisible, usersId }) => {
    const dispatch = useDispatch();

    const user = useSelector((state => state.adminPanel.selectedUser));
    const [userID, setUserID] = useState(user?.id);
    const [userFirstName, setUserFirstName] = useState(user?.firstName);
    const [userLastName, setUserLastName] = useState(user?.lastName);
    const [userEmail, setUserEmail] = useState(user?.email);
    const [userGroup, setUserGroup] = useState(user ? user.groups ? user.groups.map(item=>item.name) : "" : "");
    const [intGroup, setInitGroup] = useState(user ? user.groups ? user.groups.map(item=>item.name) : "" : "");
    const [firstCheck, setFirstCheck] = useState(false);
    const [secondCheck, setSecondCheck] = useState(false);
    const [edited, setEdited] = useState(false);
    const [groups, setGroups] = useState([]);
    const [userInfo, setUserInfo] = useState(JSON.stringify(user?.info));
    const [hintJSON, setHintJSON] = useState("");
    const [displayedInfo, setDisplayedInfo] = useState("");
    const [msg, setMsg] = useState("");

    const checkJSONStructure = str => {
        try {
          JSON.parse(str);
          setHintJSON("");
        } catch (e) {
          setHintJSON(e.name + ": " + e.message);
          return false;
        }
        return true;
    };
    const prettify = value => {
        try {
          if (checkJSONStructure(value)) {
            setHintJSON("");
            const ugly = JSON.parse(value);
            const pretty = JSON.stringify(ugly, undefined, 4);
            return pretty;
          }
        } catch (err) {
          console.log(err);
          setHintJSON(err);
        }
        return value;
    };

    useEffect(()=>{
        if(userInfo){
            setDisplayedInfo(prettify(userInfo));
        }
    },[userInfo])

    useEffect(() => {
        if(usersId){
            dispatch(getUserData(usersId));
        }
    }, [usersId, edited]);

    useEffect(()=>{
        getGroups().then(groups => {
            setGroups(groups.map(item=>item.name));
            }).catch(error => {
            console.error("Error fetching groups:", error);
            });
    },[]);

    useEffect(()=>{
        setUserID(user?.id);
        setUserFirstName(user?.firstName);
        setUserLastName(user?.lastName);
        setUserEmail(user?.email);
        setUserGroup(user ? user.groups ? user.groups.map(item=>item.name) : "" : "");
        setInitGroup(user ? user.groups ? user.groups.map(item=>item.name) : "" : "");
        setUserInfo(JSON.stringify(user?.info));
        setEdited(false);
    },[user, edited]);

    const handleOk = () => {
        if (checkJSONStructure(prettify(displayedInfo))) {
            setMsg("");
            if(firstCheck){
                dispatch(updateUser(userID, userEmail, userFirstName, userLastName, JSON.parse(prettify(displayedInfo))));
                setFirstCheck(false);
                setEdited(true);
            }
            if(secondCheck){
                dispatch(clearUserGroups(userID, intGroup))
                .then(() => {
                    return dispatch(updateUserGroup(userID, userGroup));
                })
                setSecondCheck(false);
            }
            setVisible(false);
        } else {
            setMsg("Can't edit JSON that is not valid");
        }
    }

    return (
      <Modal
        isVisible={isVisible}
        Icon={Pencil}
        onCancel={() => setVisible(false)}
        onOk={()=> handleOk()}
        title={<h1 style={{color:"#2d97e9", marginTop:"0.563rem", marginLeft:"1.875rem"}}>Edit User</h1>}
        width={817}
        okText="Edit User"
      >
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>User ID</span>
            <Input disabled style={{height:"40px"}} value={userID}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Email</span>
            <Input style={{height:"40px"}} value={userEmail} onChange={event=>{setUserEmail(event.target.value); setFirstCheck(true);}}></Input>
        </div>
        <div style={{marginTop:"20px", display:"flex"}}>
            <div>
                <span className='input-titles'>First Name</span>
                <Input style={{width:"350px",height:"40px"}} value={userFirstName} onChange={event=>{setUserFirstName(event.target.value); setFirstCheck(true);}}></Input>
            </div>
            <div style={{marginLeft:"65px"}}>
                <span className='input-titles'>Last Name</span>
                <Input style={{width:"350px",height:"40px"}} value={userLastName} onChange={event=>{setUserLastName(event.target.value); setFirstCheck(true);}}></Input>
            </div>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Group</span>
            <Select
                showSearch={false}
                size="small"
                mode="multiple"
                value={userGroup}
                placeholder="Select a group"
                onChange={value=>{setUserGroup(value); setSecondCheck(true);}}
                options={groups.map(item => ({
                    label: item,
                    value: item
                  }))}
            />
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Info</span>
            <Input.TextArea style={{height:"100px"}} value={displayedInfo} onChange={event=>{setDisplayedInfo(event.target.value); setFirstCheck(true);}}/>
        </div>
        <div>
            {msg && <span style={{color:"#f76b8a"}}>{msg}</span>}
        </div>
      </Modal>
    );
  };
  
  export default EditModal;